import React, { useEffect, useRef } from "react"
import { createRoot } from "react-dom/client"
import MonolineTextBlock from "components/monoline"

import imageTraceableIngredients from "images/shop/traceable-ingredients.png"
import imageNonGMO from "images/shop/non-gmo.png"
import FeatureHighlights from "components/text-and-media/feature-highlights"

import {
  Logo,
  Preheading,
  Heading,
  Subheading,
  Body,
  BodyImage,
  LayoutPreheading,
  LayoutHeading,
  LayoutButton,
} from "./styles"

const icons = {
  "shop-traceable-ingredients": imageTraceableIngredients,
  "shop-non-gmo": imageNonGMO,
}

const HeroContent = ({
  className,
  preheading,
  heading,
  subheading,
  body,
  isArticle,
  featureHighlights,
  isLayoutContainer,
  buttonElement,
}) => {
  const getPreheadingText = (html) =>
    html.replace(/<em>([^<]*)<\/em>/gi, (...args) => {
      const [, p1] = args

      if (p1.toLowerCase().startsWith("sponsored by")) {
        return `<span class="sponsored-by">${p1}</span>`
      }

      return p1
    })

  const refBody = useRef()
  useEffect(() => {
    const renderIcon = (parent, component) => {
      const text = parent.textContent
      const parentClone = parent.cloneNode(false)
      parent.parentNode.replaceChild(parentClone, parent)
      const container = document.createElement("span")
      container.style.display = "flex"
      container.style.flexDirection = "column"
      parentClone.appendChild(container)
      const root = createRoot(container)
      root.render(
        <>
          {component}
          {text}
        </>,
      )
    }

    if (refBody.current) {
      const bodyElement = refBody.current
      const iconElements = bodyElement.getElementsByTagName("icon")
      Array.from(iconElements).forEach((iconElement) => {
        renderIcon(
          iconElement.parentElement,
          <BodyImage src={icons[iconElement.id]} width={58} height={58} />,
        )
      })
    }
  }, [])

  return (
    <span className={className}>
      {preheading && preheading.logo && (
        <Logo
          aspectRatio={preheading.aspectLogo}
          baseUrl={preheading.logo}
          images={[{ transforms: "e_trim/h_35,q_90,f_auto,fl_lossy" }]}
          alt={heading.text || ""}
          left={preheading.logoLeft}
        />
      )}
      {preheading && preheading.monolineText && !preheading.text && (
        <h3 className="monoline">
          <MonolineTextBlock html={preheading.monolineText} />
        </h3>
      )}
      {preheading &&
        !preheading.monolineText &&
        preheading.text &&
        (isLayoutContainer ? (
          <LayoutPreheading
            dangerouslySetInnerHTML={{ __html: getPreheadingText(preheading.text) }}
            useLineOnMobile={preheading.useLineOnMobile}
          />
        ) : (
          <Preheading
            dangerouslySetInnerHTML={{ __html: getPreheadingText(preheading.text) }}
            useLineOnMobile={preheading.useLineOnMobile}
          />
        ))}

      {heading &&
        (heading.monolineText ? (
          <h2>
            <MonolineTextBlock html={heading.monolineText} />
          </h2>
        ) : heading.serifText ? (
          isLayoutContainer ? (
            <LayoutHeading dangerouslySetInnerHTML={{ __html: heading.serifText }} isSerif />
          ) : (
            <Heading dangerouslySetInnerHTML={{ __html: heading.serifText }} isSerif />
          )
        ) : isLayoutContainer ? (
          <LayoutHeading dangerouslySetInnerHTML={{ __html: heading.text }} />
        ) : (
          <Heading dangerouslySetInnerHTML={{ __html: heading.text }} />
        ))}
      {subheading && <Subheading dangerouslySetInnerHTML={{ __html: subheading }} />}
      {body && (
        <Body ref={refBody} isArticle={isArticle} dangerouslySetInnerHTML={{ __html: body }} />
      )}
      {featureHighlights && <FeatureHighlights highlights={featureHighlights} />}
      {buttonElement && isLayoutContainer && <LayoutButton>{buttonElement}</LayoutButton>}
    </span>
  )
}

export default HeroContent
